<template>
  <div class="Order">
    <Header/>
    <div class="content">
      <div class="current-loc">
        <span>{{ $t('satellite.CurrentPosition') }}：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{ $t('satellite.Home') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('header.PersonalCenter') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('Order.MyOrder') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <p class="title">{{ $t('Order.MyOrder') }}</p>
      <hr>
      <div class="query">
        {{ $t('Order.Orderquery') }}：
        <el-input class="search" size="mini" :placeholder="$t('Order.Please')" v-model="query.orderId"></el-input>
        <el-button class="search-btn" size="mini" @click="getDatas">{{ $t('Order.query') }}</el-button>
        <el-button size="mini" @click="deletesMore">{{ $t('Order.Batchdelete') }}</el-button>
      </div>
      <div class="data-table">
        <el-table
            :header-cell-style="header_cell_style_bd"
            :cell-style="cell_style_bd"
            :style="cell_style_bd"
            ref="tablesOrder"
            :empty-text="$t('Intelligent.NoData')"
            :data="tableData"
            border>
          <el-table-column
              type="selection"
              width="55">
          </el-table-column>
          <el-table-column
              type="index"
              :label="$t('Order.number')"
              align="center"
              width="50">
          </el-table-column>
          <el-table-column
              prop="pkid"
              :label="$t('Order.OrderNo')"
              align="center"
              width="180">
            <template slot-scope="scope">
              <span @click="viewDetail(scope.row)"
                    style="color:rgba(24,144,255,1);cursor:pointer">{{ scope.row.pkid }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="createDate"
              :label="$t('Order.subscriptiondate')"
              align="center"
              width="180">
          </el-table-column>
          <el-table-column
              prop="downloadExpire"
              :label="$t('Order.Downloadvalidity')"
              align="center">
          </el-table-column>
          <el-table-column
              prop="orderNum"
              :label="$t('Order.Numberofdata')"
              align="center">
          </el-table-column>
          <el-table-column
              prop="spaceUsage"
              :label="$t('Order.Totaldatavolume')"
              align="center">
            <template slot-scope="scope">
              <span>{{ byte2Auto(scope.row.spaceUsage) }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="address"
              :label="$t('Order.Orderstatus')"
              align="center">
            <template slot-scope="scope">
              <div class="order-status center">
                <div :class="orderStatus(scope.row.orderStatusName)"></div>
                <span>{{ $t(`Order.${scope.row.orderStatusName}`) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Order.operation')"
                           align="center">
            <template slot-scope="scope">
              <div v-if="compareTime(Date.parse(scope.row.downloadExpire))">
                <div v-if="scope.row.orderStatusName==='准备完成'">
                                <span
                                    @click="openDownPenl(scope.row.pkid)"
                                    style="color:rgba(24,144,255,1);cursor:pointer;">{{
                                    $t('Order.ViewingtheDownloadlist')
                                  }}</span>
                  <br/>
                  <span
                      @click="copyDownUrl(scope.row.pkid)"
                      style="color:rgba(24,144,255,1);cursor:pointer;">{{
                      $t('Order.Oneclicktoobtainthedownloadaddress')
                    }}</span>
                </div>
                <div v-else>
                                <span
                                    style="color:rgb(108 108 108);cursor:default;">{{
                                    $t('Order.ViewingtheDownloadlist')
                                  }}</span>
                  <br/>
                  <span
                      style="color:rgb(108 108 108);cursor:default;">{{
                      $t('Order.Oneclicktoobtainthedownloadaddress')
                    }}</span>
                </div>
              </div>
              <span v-else>{{ $t('Order.Thedownloadperiodhasexpired') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation">
        <el-pagination
            background
            @current-change="currentChange"
            layout="prev, pager, next"
            :total="total"
            :page-size="20">
        </el-pagination>
      </div>
    </div>
    <Footer/>
    <el-dialog
        :custom-class="themeStatis==='theme1'?'dialog-new-bg-b':'dialog-new-bg-w'"
        :title="$t('Order.Orderdetails')"
        :visible.sync="orderDetail"
        center>
      <div class="order-detail">
        <div class="order-process">
          <p class="order-title">
            <span class="o1">{{ $t('Order.OrderNo') }}:{{ currentOrder.pkid }}</span>
            <span class="o2">{{ $t('Order.Orderstatus') }}：<span>{{
                $t(`Order.${currentOrderStatus.dicItemName}`)
              }}</span></span>
          </p>
          <div class="time-line">
            <div class="line-site" v-for="(i,index) in orderStatusList" :key="i.index">
              <div class="circle"
                   :style="{background:(currentOrderStatusIndex<index?'rgba(191,191,191,1)':'rgba(25,144,255,1)')}">
                <div class="line"
                     :style="{background:(currentOrderStatusIndex<index+1?'rgba(191,191,191,1)':'rgba(25,144,255,1)')}"
                     v-if="index!=orderStatusList.length-1"></div>
              </div>
              <p>{{ $t(`Order.${i.dicItemName}`) }}</p>
              <p>{{ getOrderStatusLTimeListNow.length > index ? getOrderStatusLTimeListNow[index].createTime : '' }}</p>
            </div>
          </div>
        </div>
        <div class="data-list">
          <el-table
              :header-cell-style="header_cell_style_bd"
              :cell-style="cell_style_bd"
              :style="cell_style_bd"
              :data="orderDataList"
              max-height="300"
              border>
            <el-table-column
                type="index"
                :label="$t('Order.number')"
                align="center"
                width="50">
            </el-table-column>
            <el-table-column
                prop="productName"
                :label="$t('DataSubmission.ProductName')"
                align="center">
            </el-table-column>
            <el-table-column
                prop="fileSize"
                :label="$t('product.FileSize')"
                align="center"
                width="220">
              <template slot-scope="scope">
                <span>{{ byte2Auto(scope.row.fileSize) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="address"
                :label="$t('DataSubmission.State')"
                width="120"
                align="center">
              <template slot-scope="scope">
                <span>{{ $t(`Order.${scope.row.orderStatusName}`) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :title="$t('Order.FileDownloadlist')"
        :custom-class="themeStatis==='theme1'?'dialog-new-bg-b':'dialog-new-bg-w'"
        :visible.sync="downDialog"
        width="75%">
      <div class="down-dialog-main">
        <el-table
            v-loading="downTableListLoading"
            :header-cell-style="header_cell_style_bd"
            :cell-style="cell_style_bd"
            :style="cell_style_bd"
            ref="tablesOrderList"
            :data="downTableList"
            :empty-text="$t('Intelligent.NoData')"
            border>
          <el-table-column
              type="index"
              width="55">
          </el-table-column>
          <el-table-column
              prop="productName"
              :label="$t('Order.Productname')"
              width="300"
              :show-overflow-tooltip="true"
              align="center">
          </el-table-column>
          <el-table-column
              prop="fileName"
              :label="$t('Order.filename')"
              align="center"
              :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
              :label="$t('product.Operation')"
              align="center"
              width="120">
            <template slot-scope="scope">
              <span style="color:rgba(24,144,255,1);cursor:pointer"
                    @click="down(scope.row.downloadUrl)">{{ $t('product.download') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="center" style="margin-top:12px;">
          <el-pagination
              background
              :current-page="downQuery.page"
              @current-change="currentDownChange"
              layout="prev, pager, next"
              :total="downTotal"
              :page-size="10">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import {mapGetters} from "vuex";
import {
  deleteOrders,
  getOrderList,
  getOrderProductById,
  getOrderStatusList,
  getOrderStatusById,
  getDownloadUrl,
  getOrderStatusLTimeList
} from "@/api/Order/index"

export default {
  name: 'Order',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      passw: "password",
      downDialog: false,
      getOrderStatusLTimeListNow: [],
      currentOrderStatus: {},
      currentOrderStatusIndex: 0,
      orderStatusList: [],
      downTotal: 0,
      downTableList: [],
      downTableListLoading: false,
      downQuery: {
        page: 1,
        limit: 10,
        orderId: ''
      },
      query: {
        orderId: '',
        page: 1,
        limit: 20
      },
      ftpInfo: {
        downloadUrl: '',
        downloadPwd: '',
        downloadExpire: '',
      },
      total: 100,
      orderDetail: false,
      tableData: [],
      currentOrder: {},
      orderDataList: [],
      isEnglish: false
    }
  },
  computed: {
    ...mapGetters(['header_cell_style_bd', 'cell_style_bd', 'themeStatis']),
    showViewP() {
      return "下载地址：" + this.ftpInfo.downloadUrl + ",过期时间：" + this.ftpInfo.downloadExpire + "，密码：" + this.ftpInfo.downloadPwd
    },
  },
  methods: {
    /**
     * @description:
     * @brief:
     * @Author: chenwei
     * @Date: 2022-07-11 19:11:42
     * @param {*} frontTime
     * @param {*} endTime
     * @return {*}
     */
    compareTime(frontTime) {
      frontTime = parseInt(frontTime)
      const endTime = Date.parse(new Date())
      if (frontTime > endTime) {
        return true
      } else {
        return false
      }
    },
    copyDownUrl(orderId) {
      this.$router.push({
        path:'/downfile',
        query:{
          orderId:orderId
        }
      })
    },
    deletesMore() {
      let selected = this.$refs.tablesOrder.selection
      let paramas = selected.map(item => item.pkid)
      this.deleteOrder(paramas)
    },
    async deleteOrder(val) {
      let res = await deleteOrders({
        orderIds: val
      })
      if (res.code === '000000') {
        this.$message.success(this.isEnglish ? 'successfully delete' : '删除成功！')
      }

      this.getDatas()
    },
    firstCopySuccess(e) {
      console.log("copy arguments e:", e);
      this.$message.success(this.isEnglish ? 'Copy success' : '复制成功!')
    },
    firstCopyError(e) {
      console.log("copy arguments e:", e);
      this.$message.error(this.isEnglish ? 'Copy the failure' : '复制失败!')
    },
    showPass() {
      if (this.passw == "text") {
        this.passw = "password";
        //更换图标
        this.icon = "el-input__icon el-icon-view";
      } else {
        this.passw = "text";
        this.icon = "el-input__icon el-icon-loading";
      }
    },
    currentChange(val) {
      this.query.page = val
      this.getDatas()
    },
    /**
     * @description: 打开dialog
     * @brief:
     * @Author: chenwei
     * @Date: 2022-07-11 19:28:21
     * @param {*} id
     * @return {*}
     */
    openDownPenl(id) {
      this.downQuery.page = 1
      this.downQuery.orderId = id
      this.getDownList(id)
      this.downDialog = true
      this.downTableListLoading = true
    },
    async getDownList() {
      let res = await getDownloadUrl(this.downQuery)
      this.downTableList = res.data.list
      this.downFileList = res.data.list
      this.downTotal = parseInt(res.data.totalCount)
      this.downTableListLoading = false
    },
    currentDownChange(val) {
      this.downQuery.page = val
      this.getDownList()
    },
    /**
     * @description: 下载
     * @brief:
     * @Author: chenwei
     * @Date: 2022-07-11 19:28:50
     * @param {*} url
     * @return {*}
     */
    down(url) {
      window.open(url)
    },
    orderStatus(val) {
      switch (val) {
        case '提交订单':
          return "order-status3"
        case '数据准备':
          return "order-status2"
        default:
          return "order-status1"
      }
    },
    viewDetail(val) {
      this.currentOrder = val
      this.orderDetail = true
      this.getOrderNowStatus(val.pkid)
      this.getSiteDataList(val.pkid)
      this.getOrderStatusLTimeListFuc(val.pkid)
    },
    async getOrderStatusLTimeListFuc(val) {
      let {data} = await getOrderStatusLTimeList({orderId: val})
      let res = data
      this.getOrderStatusLTimeListNow = res
    },
    async getDatas() {
      let {data} = await getOrderList(this.query)
      let res = data
      this.tableData = res.list
      this.total = parseInt(res.totalCount)
    },
    async getSiteDataList(val) {
      let that = this
      let {data} = await getOrderProductById({orderId: val})
      let res = data
      that.orderDataList = res.list
      that.orderDataList.forEach(item => item.orderStatusName = that.currentOrderStatus.dicItemName)
    },
    async getOrderStatus() {
      let {data} = await getOrderStatusList({code: 'ORDER_STATUS'})
      let res = data
      this.orderStatusList = res
    },
    async getOrderNowStatus(val) {
      let that = this
      let {data} = await getOrderStatusById({id: val})
      let res = data
      that.currentOrderStatusIndex = that.orderStatusList.findIndex(item => item.pkid == res.orderStatus)
      that.currentOrderStatus = that.orderStatusList[that.currentOrderStatusIndex]
    }
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  },
  created() {
    this.getOrderStatus()
    this.getDatas()
  }
}
</script>

<style lang="scss" scoped>

.fpt-a {
  font-size: 15px;
  color: rgba(38, 125, 255, 1);
  text-decoration: none
}

hr {
  @include hr_white_to_black();
}

.current-loc {
  height: 21px;
  display: flex;
  align-items: center;
  margin-top: 60px;

  /deep/ span {
    font-size: 15px;
    @include co_white_to_black();
  }

  /deep/ a {
    @include co_white_to_black();
  }

  /deep/ .el-breadcrumb__item:last-child {
    span {
      color: rgba(38, 125, 255, 1);
    }
  }
}

.down-dialog-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .down-dialog-site {
    margin-bottom: 12px;

    span {
      display: inline-block;
      width: 100px;
      text-align: right;
    }

  }
}

.Order {
  width: 100%;
  @include table_page_bg();

  .content {
    min-height: 600px;
    margin: 0 auto;
    width: 1551px;

    .label {
      margin: 60px 0 20px 0;
    }

    .title {
      font-size: 28px;
      color: rgba(39, 121, 202, 1);
      margin: 20px 0;
    }

    .query {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 15px;
      margin: 20px 0;

      .search {
        width: 240px;
        margin: 0 12px;
      }

      .search-btn {
      }
    }

    .data-table {
      margin: 20px 0;

      .order-status1 {
        width: 8px;
        height: 8px;
        border-radius: 50px;
        background: green;
        margin-right: 8px
      }

      .order-status2 {
        @extend .order-status1;
        background: rgba(24, 144, 255, 1);
      }

      .order-status3 {
        @extend .order-status1;
        background: rgba(215, 218, 225, 1);
      }

      .order-status {
      }
    }

    .pagenation {
      display: flex;
      justify-content: flex-end;
      padding-right: 0;
      margin: 20px 0;
    }
  }

  .order-detail {
    width: 100%;
    max-height: 600px;

    .order-process {
      width: 100%;
      @include product_upload_label_co();
      @include order_dialog_bg();
      padding: 24px 0;

      .order-title {
        padding: 0 48px;
        display: flex;
        justify-content: space-between;
        margin: 12px 0;

        .o1 {
          font-weight: 700;
          font-size: 18px;
        }

        .o2 {
        }
      }

      .time-line {
        display: flex;
        justify-content: center;
        margin: 24px 0;

        .line-site {
          width: 196px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .circle {
            position: relative;
            width: 10px;
            height: 10px;
            border-radius: 50px;
            background: rgba(25, 144, 255, 1);

            .line {
              width: 180px;
              height: 2px;
              border: 0;
              //    background: rgba(232,232,232,1);
              background: rgba(25, 144, 255, 1);
              position: absolute;
              left: 13px;
              top: 50%;
              transform: translate(0, -50%);
            }
          }

          .circle-b {
            position: relative;
            width: 5px;
            height: 5px;
            border-radius: 50px;
            background: rgba(191, 191, 191, 1);

            .line {
              width: 180px;
              height: 2px;
              border: 0;
              //    background: rgba(232,232,232,1);
              background: rgba(232, 232, 232, 1);
              position: absolute;
              left: 8px;
              top: 50%;
              transform: translate(0, -50%);
            }
          }
        }
      }
    }

    .data-list {
      margin-top: 36px;
    }
  }

  ::v-deep .btn-next {
    margin-right: 0;
  }

  ::v-deep .el-pagination {
    padding-right: 0;
  }
}

/deep/ .dialog-new-bg-w {
  background: white;

  .el-form-item__label {
    color: black
  }

  .el-dialog, .el-pager li {
    background: white

  }

  .el-dialog__title {
    color: black
  }
}

/deep/ .dialog-new-bg-b {
  background: rgb(29, 29, 29);

  .el-form-item__label {
    color: white;
  }

  .el-dialog, .el-pager li {
    background: rgb(29, 29, 29)

  }

  .el-dialog__title {
    color: white;
  }
}
</style>